import { css } from "@emotion/core";

export const spinnerStyleMixin = css`
  display: block;
  margin: 30vh auto 0;
`;
